/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
    EfsMelcoModelsPreview,
    EfsMelcoModelsPreviewFromJSON,
    EfsMelcoModelsPreviewFromJSONTyped,
    EfsMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsUserAlphabet
 */
export interface EfsMelcoModelsUserAlphabet {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    style?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    service_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    recommended_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    file_name: string;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    file_size: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    original_file_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    publish_state?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    rfm_url?: string | null;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {Array<EfsMelcoModelsPreview>}
     * @memberof EfsMelcoModelsUserAlphabet
     */
    previews?: Array<EfsMelcoModelsPreview> | null;
}

export function EfsMelcoModelsUserAlphabetFromJSON(json: any): EfsMelcoModelsUserAlphabet {
    return EfsMelcoModelsUserAlphabetFromJSONTyped(json, false);
}

export function EfsMelcoModelsUserAlphabetFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsUserAlphabet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'style': !exists(json, 'style') ? undefined : json['style'],
        'service_id': !exists(json, 'service_id') ? undefined : json['service_id'],
        'service_name': !exists(json, 'service_name') ? undefined : json['service_name'],
        'recommended_text': !exists(json, 'recommended_text') ? undefined : json['recommended_text'],
        'type': json['type'],
        'signature': json['signature'],
        'file_name': json['file_name'],
        'file_size': json['file_size'],
        'original_file_name': !exists(json, 'original_file_name') ? undefined : json['original_file_name'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'rfm_url': !exists(json, 'rfm_url') ? undefined : json['rfm_url'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(EfsMelcoModelsPreviewFromJSON)),
    };
}

export function EfsMelcoModelsUserAlphabetToJSON(value?: EfsMelcoModelsUserAlphabet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'style': value.style,
        'service_id': value.service_id,
        'service_name': value.service_name,
        'recommended_text': value.recommended_text,
        'type': value.type,
        'signature': value.signature,
        'file_name': value.file_name,
        'file_size': value.file_size,
        'original_file_name': value.original_file_name,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'publish_state': value.publish_state,
        'rfm_url': value.rfm_url,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(EfsMelcoModelsPreviewToJSON)),
    };
}


